import type { StartDetectionRunRequest } from '@prerender/diagnostics-api';
import { useState } from 'react';

import { useGetCountersQuery } from './countersApi';
import { cooldownOf, type RunCooldown } from './runCooldown';

export type RunConfirmation = ({ kind: 'inside-cooldown' } & RunCooldown) | { kind: 'no-new-data' };

export type RunConfirmationControls = {
  confirmation: RunConfirmation | undefined;
  request: () => void;
  offerRunAnyway: () => void;
  confirm: () => void;
  cancel: () => void;
};

export function useRunConfirmation(
  enabled: boolean,
  start: (request: StartDetectionRunRequest) => void
): RunConfirmationControls {
  const { data: counters } = useGetCountersQuery(undefined, { skip: !enabled });
  const [confirmation, setConfirmation] = useState<RunConfirmation>();

  return {
    confirmation,
    request: () => {
      const cooldown = cooldownOf(counters, new Date());
      if (cooldown === undefined) {
        start({ force: false });
        return;
      }

      setConfirmation({ kind: 'inside-cooldown', ...cooldown });
    },
    offerRunAnyway: () => setConfirmation({ kind: 'no-new-data' }),
    confirm: () => {
      setConfirmation(undefined);
      start({ force: true });
    },
    cancel: () => setConfirmation(undefined),
  };
}
